import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

import { ItemCard, SharingPopup, AddFavorite } from 'C4';
import { appContentUrl, baseAppId } from 'settings';

const SwitchLink = (props) => {
  const { isLink, children, url } = props;
  return isLink ? (
    <Link to={`/main/sell/${url}`}>{children}</Link>
  ) : (
    <a href={url}>{children}</a>
  );
};

const init = (type) => {
  switch (type) {
    case 'carousel':
      return { icon: 'fa-images', isAppContent: true };
    case 'pdf':
      return { icon: 'fa-file-alt', isAppContent: false };
    case 'web':
      return { icon: 'fa-link', isAppContent: false };
    case 'contact':
      return { icon: 'fa-comments', isAppContent: true };
    case 'layout':
      return { icon: 'fa-clipboard', isAppContent: true };
    default:
      return '';
  }
};

export default class FancyboxTrigger extends Component {
  constructor(props) {
    super(props);

    const { icon, isAppContent } = init(props.type);

    this.state = {
      icon,
      url: null,
      isAppContent,
    };
  }

  componentDidMount() {
    this.parseURL();
  }

  parseURL() {
    const { url } = this.props;
    if (url.includes(',')) {
      this.setState({ url: url.split(',') });
    } else this.setState({ url: [url] });
  }

  render() {
    const { icon, url, isAppContent } = this.state;
    const { image, title, subtitle, itemID, element, hasFavourite, className } =
      this.props;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['thumbs', 'download', 'share', 'close'],
      share: {
        tpl: renderToString(<SharingPopup url={window.location.href} />),
      },
    };

    const fav = { appId: window.appId, viewType: 't', upID: itemID };

    return (
      url && (
        <div
          data-trigger={isAppContent ? null : itemID}
          data-fancybox-rel={isAppContent ? null : itemID}
          data-options={isAppContent ? null : fancyOptions}
          className={`container__fancybox${` ${className}` || ''}`}
        >
          <SwitchLink isLink={isAppContent} url={url[0]}>
            {hasFavourite && <AddFavorite {...fav} />}
            {element && element}
            {element === null && (
              <ItemCard
                buttonIcon={icon}
                buttonText={i18n.translate('fastFacts.view')}
                image={`${appContentUrl}${baseAppId}/salesCompanion/${image}`}
                imageType="css"
                subtitle={subtitle}
                title={title}
              />
            )}
          </SwitchLink>
          {typeof url === 'object' &&
            !isAppContent &&
            url.map((u) => (
              <div
                key={u}
                data-fancybox={itemID}
                data-type="iframe"
                href={
                  u.includes('http')
                    ? u
                    : `${appContentUrl}${baseAppId}/salesCompanion/${u}`
                }
              />
            ))}
        </div>
      )
    );
  }
}

FancyboxTrigger.propTypes = {
  element: PropTypes.node,
  hasFavourite: PropTypes.bool,
  image: PropTypes.string,
  itemID: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
};

FancyboxTrigger.defaultProps = {
  element: null,
  hasFavourite: true,
  image: '',
  itemID: null,
  subtitle: '',
  title: '',
  type: null,
  url: '',
};

SwitchLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isLink: PropTypes.bool,
  url: PropTypes.string,
};

SwitchLink.defaultProps = {
  children: [],
  isLink: false,
  url: '',
};
